import { getCountryNameByCountryCode, getStatusDescriptionFromStatusValue, getOrderTypeText } from '../../../../../utils/utility';
import { getDateWithSpecificFormat } from '../../../../data-transform';

export default function quoteDetailsTableColumns(config) {
    let result = {};
    let tableData = [];

    config.data.forEach(quoteDetailsDRS => {
        let row = [];
        const rowId = quoteDetailsDRS.quoteId;
        config.columns.forEach(column => {
            let columnValue = "";
            let linkDestination = "";

            let displayAsIs = column.data.displayInBodyAsIs;
            if (column.data.displayInBodyAs === "string") {
                if (column.id === "quoteNumber") {
                    columnValue = quoteDetailsDRS.quoteId || "";
                    displayAsIs = true;
                }
                if (column.id === "quoteCreationDate") {
                    columnValue = getDateWithSpecificFormat(quoteDetailsDRS.createdDate) || "";
                    displayAsIs = true;
                }
                if (column.id === "orderType") {
                    columnValue = getOrderTypeText(quoteDetailsDRS.orderType) || "";
                    displayAsIs = true;
                }
                if (column.id === "country") {
                    columnValue = getCountryNameByCountryCode(quoteDetailsDRS.countryCode) || "";
                    displayAsIs = true;
                }
                if (column.id === "companyName") {
                    columnValue = quoteDetailsDRS.company || "";
                    displayAsIs = true;
                }
                if (column.id === "legalEntityName") {
                    columnValue = quoteDetailsDRS.legalEntity || "";
                    displayAsIs = true;
                }
                if (column.id === "collectionCity") {
                    columnValue = quoteDetailsDRS.shippingAddress && quoteDetailsDRS.shippingAddress.city ? quoteDetailsDRS.shippingAddress.city : "-";
                    displayAsIs = true;
                }
                if (column.id === "status") {
                    columnValue = getStatusDescriptionFromStatusValue(quoteDetailsDRS.status) || "";
                    displayAsIs = true;
                }
                if (column.id === "priceUploadedDate") {
                    columnValue = getDateWithSpecificFormat(quoteDetailsDRS.priceUploadedDate) || "";
                    displayAsIs = true;
                }
                if (column.id === "qtyOfAssets") {
                    columnValue = quoteDetailsDRS.totalDevicesQuoted;
                    displayAsIs = true;
                }
                if (column.id === "currency") {
                    columnValue = quoteDetailsDRS.currencyCode || "";
                    displayAsIs = true;
                }
                if (column.id === "quotedNetValue") {
                    columnValue = !isNaN(quoteDetailsDRS.cnetValue) ? quoteDetailsDRS.cnetValue?.toFixed(2)  : "";
                    displayAsIs = true;
                }
                if (column.id === "quotedHWBuybackValue") {
                    columnValue = !isNaN(quoteDetailsDRS.chwBuyBackValue) ? quoteDetailsDRS.chwBuyBackValue?.toFixed(2) : "";
                    displayAsIs = true;
                }
                if (column.id === "quotedServiceCost") {
                    columnValue = !isNaN(quoteDetailsDRS.cserviceCost) ? quoteDetailsDRS.cserviceCost?.toFixed(2) : "";
                    displayAsIs = true;
                }
                if (column.id === "vendorQuotedNetValue") {
                    columnValue = quoteDetailsDRS.vnetValue !== null && quoteDetailsDRS.vnetValue !== undefined ? !quoteDetailsDRS.vnetValue || quoteDetailsDRS.vnetValue?.toFixed(2) : "";
                    displayAsIs = true;
                }
                if (column.id === "vendorQuotedHWBuybackValue") {
                    columnValue = quoteDetailsDRS.vhwBuyBackValue !== null && quoteDetailsDRS.vhwBuyBackValue !== undefined ? quoteDetailsDRS?.vhwBuyBackValue?.toFixed(2) || quoteDetailsDRS.vhwBuyBackValue.toFixed(2) : "";
                    displayAsIs = true;
                }
                if (column.id === "vendorQuotedServiceCosts") {
                    columnValue = quoteDetailsDRS.vserviceCost !== null && quoteDetailsDRS.vserviceCost !== undefined ? !quoteDetailsDRS.vserviceCost || quoteDetailsDRS.vserviceCost?.toFixed(2) : "";
                    displayAsIs = true;
                }
                if (column.id === "hpPriceUploadDate") {
                    columnValue = getDateWithSpecificFormat(quoteDetailsDRS.hpUplaodMapDate) || "";
                    displayAsIs = true;
                }
                if (column.id === "quantityOfRevitalizeAssets") {
                    columnValue = quoteDetailsDRS.numberOfRevitalizeAssets;
                    displayAsIs = true;
                }
                if (column.id === "hpQuotedHwBuybackValue") {
                    columnValue = quoteDetailsDRS.revitalizeHPPrices !== null && quoteDetailsDRS.revitalizeHPPrices !== undefined ? quoteDetailsDRS?.revitalizeHPPrices?.toFixed(2) : "";
                    displayAsIs = true;
                }
                if (column.id === "vendorQuotedRevitalizeFees") {
                    columnValue = quoteDetailsDRS?.vhardwareRevitalizeFees?.toFixed(2) || "";
                    displayAsIs = true;
                }
            }

            row.push({
                [column.id]: {
                    id: column.id + "|" + rowId,
                    type: column.data.displayInBodyAs,
                    value: columnValue,
                    width: column.width,
                    displayAsIs: displayAsIs,
                    linkDestination: linkDestination,
                    showInMobileViewAs: column.showInMobileViewAs
                }
            });
        });

        tableData.push({
            id: rowId,
            data: row
        });
    });


    result['columns'] = config.columns;
    result['data'] = tableData;

    return result;
}